import React, { useState,useEffect } from 'react';
import "./css/homepage_help.css";
import logo from "./images/logo_ticket_buydeal.jpg";
import { useNavigate } from 'react-router-dom';

const HomePageHelp = () => {
	const navigate = useNavigate();
	
	const [openIndex, setOpenIndex] = useState(null);
	
	const faqs = [
	    {
	      question: "I have paid but not received any email confirmation",
	      answer:
	        "Please check your spam or junk folder first. If you still cannot find the confirmation email, make sure the email address entered during checkout was correct. You can also contact our support team contact@buydeal.eu with your payment reference for assistance."
	    },
		{
		  question: "I entered the wrong email address during purchase",
		  answer:
		    "If you entered an incorrect email address, please contact our support team contact@buydeal.eu as soon as possible with your order details so we can help you in resending the email."
		},
	    {
	      question: "Can I cancel my ticket?",
	      answer:
	        "Ticket cancellations are subject to the event organiser’s cancellation policy. Please review the event details or contact the organiser directly for cancellation requests.The organiser contact details are available in your email confirmation."
	    },
	    {
	      question: "Can I get a refund for my ticket?",
	      answer:
	        "Refunds depend on the organiser’s refund policy. Some events offer full or partial refunds, while others may be non-refundable. The organiser contact details are available in your email confirmation."
	    },
	    {
	      question: "Can I transfer my ticket to someone else?",
	      answer:
	        "Ticket transfer availability depends on the event organiser. Some events allow ticket transfers, while others do not. Please check the event terms or contact the organiser.The organiser contact details are available in your email confirmation."
	    },
	    {
	      question: "What should I bring to the event?",
	      answer:
	        "Most events accept digital tickets. Please bring your e-ticket (QR code) on your mobile device or a printed copy, along with a valid ID if required by the organiser."
	    }
	  ];
	  
	  
	  const toggleFAQ = (index) => {
	    setOpenIndex(openIndex === index ? null : index);
	  };


	
    return (
	<div className="mainhelp-container">		
	{/* NAVBAR */}
	<header className="navbar">
	  <div className="navbar-inner">
	    <div className="logo" onClick={() => navigate("/")}>
	    <img src={logo} alt=""/>
	      <span>Buydeal.EU</span>
	    </div>
	    <div className="nav-buttons">
	   <div className="nav-menu">
			<span className="nav-link" onClick={() => navigate("/orginfo")}>Event Organisers</span>
		</div>
		<div className="nav-menu">
			<span className="nav-link" onClick={() => navigate("/homepagehelp")}>Help</span>
		</div>		
	      <button
	        className="btn-primary"
	        onClick={() => navigate("/login")}>
	        Organiser Login
	      </button>
	    </div>
	  </div>
	</header>
	
	<section className="mainhelp">
		<div className="mainhelp-text ">
		  <h1>Help for Ticket buyers</h1>
		  
		  <p>
		  For all your ticket related queries...
		  </p>
	</div>

	</section>
	
	{/* FAQ SECTION */}
	        <div className="faq-section">
	          {faqs.map((faq, index) => (
	            <div className="faq-item" key={index}>
	              <div
	                className="faq-question"
	                onClick={() => toggleFAQ(index)}
	              >
	                <span>{faq.question}</span>
	                <span className="faq-icon">
	                  {openIndex === index ? "−" : "+"}
	                </span>
	              </div>

	              {openIndex === index && (
	                <div className="faq-answer">
	                  <p>{faq.answer}</p>
	                </div>
	              )}
	            </div>
	          ))}
	        </div>

		  
	</div>	
    );
}


export default HomePageHelp;
